<template>
  <div class="WorkCalendar">
    <box class="mt-2" v-if="showWorkCalndar" :title="this.$t('workCalendar')">
      <!-- {{workCalendar}} -->
      <v-simple-table
        dense
        fixed-header
        height="400px"
        v-if="workCalendar && workCalendar.length > 0"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th
                v-for="(item, index) in headers"
                :key="index"
                v-text="item.text"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in workCalendar"
              :key="index"
              :class="statusClass(item)"
              class="text-color-black"
            >
              <td>{{ item.Date }}</td>
              <td>{{ item.DayName }}</td>
              <td v-text="getStatusText(item)"></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <empty-list v-else />
    </box>
  </div>
</template>

<script>
import EmptyList from "../widget/EmptyList.vue";
export default {
  components: { EmptyList },
  props: {
    showWorkCalndar: Boolean,
    perno: String,
  },
  data() {
    return {
      workCalendar: null,
      headers: [
        {
          text: this.$t("DDATE"),
          value: "Date",
        },
        {
          text: this.$t("DayName"),
          value: "DayName",
        },
        {
          text: this.$t("status"),
          value: "HOLIDAY",
        },
      ],
    };
  },
  watch: {
    perno() {
      this.GetPersonCalendar();
    },
  },
  mounted() {
    this.GetPersonCalendar();
  },
  methods: {
    getStatusText(item) {
      if (item.HOLIDAY == 1) {
        return this.$t("holiday");
      } else if (item.HOLIDAY == 2) {
        return this.$t("holidayByAgreement");
      } else {
        return this.$t("workDay");
      }
    },
    statusClass(item) {
      if (item.HOLIDAY == 1) {
        return "bg-red"; //can also return multiple classes e.g ["orange","disabled"]
      }
      if (item.HOLIDAY == 2) {
        return "bg-green";
      }
    },
    GetPersonCalendar() {
      var moment = require("jalali-moment");
      this.$store.dispatch("GetPersonCalendar",this.perno).then((result) => {
        if (result.data && result.data.length > 0) {
          this.workCalendar = result.data;

          this.workCalendar.forEach((element) => {
            var DayName = moment(element.Date, "jYYYY/jMM/jDD")
              .locale("fa")
              .format("ddd");
            element.DayName = DayName;
          });
        }
      });
    },
  },
};
</script>

<style>
</style>